
import { defineComponent, ref } from 'vue';

import TableList from '@/components/tables/TableList.vue';

const columns = [
  {
    title: 'File name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Audio',
    key: 'mediaUrl',
  },
];

const listColumns = [{ title: '만든 사람', key: 'username' }];

export default defineComponent({
  name: 'UploadImage',
  components: { TableList },
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      columns,
      listColumns,
    };
  },
});
